// extracted by mini-css-extract-plugin
export default {"editable":"editable-cell_editable__xn88i","error":"editable-cell_error__vgwO5"};